import React, { useEffect, useState } from "react";
import { Mail, Phone, MapPin, RefreshCcw, ChevronDown } from "lucide-react";
import Header from "../../component/common/Header";

// ... (Social Icons and MapPlaceholder components remain same as your code)
const Facebook = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {" "}
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />{" "}
  </svg>
);
const Twitter = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {" "}
    <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-17.7 15.3 5.4-.4 10.3-3.1 13.8-7.2-2.3 1.3-4.8 1.9-7.3 1.9-2.9 0-5.7-1.1-7.8-3.2 4.4 1.4 7.5-.9 9.3-3.6-2.5 0-5-1.3-6.4-3.5 1.5.2 2.9.1 4-.3-3.4-.7-6.2-3.4-6.2-7.1v-.5c1.4.7 3.1 1.2 4.9 1.3-3.4-2.3-5.2-7.2-2.7-10.4 3.6 4.6 8.7 6.7 14 6.9-1.2-4.7 4-8.8 9.3-7.7 1.1-.2 2.1-.6 3.1-1.2-1.2 1.9-2.7 3.2-4.3 4.1z" />{" "}
  </svg>
);
const LinkedIn = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {" "}
    <path d="M16 8a6 6 0 0 0-6 6v7h4v-7a2 2 0 0 1 2-2 2 2 0 0 1 2 2v7h4v-7a6 6 0 0 0-6-6z" />{" "}
    <rect x="2" y="9" width="4" height="12" />{" "}
    <circle cx="4" cy="4" r="2" />{" "}
  </svg>
);
const YouTube = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {" "}
    <path d="M2.87 8.35c.13-.3.33-.56.57-.75C5.6 5.45 8.24 4.8 12 4.8s6.4.65 8.57 2.8c.24.2.44.45.57.75.14.33.22.69.22 1.05v5.2c0 .36-.08.72-.22 1.05-.13.3-.33.56-.57.75-2.17 2.15-4.8 2.8-8.57 2.8s-6.4-.65-8.57-2.8c-.24-.2-.44-.45-.57-.75-.14-.33-.22-.69-.22-1.05V9.4c0-.36.08-.72.22-1.05z" />{" "}
    <path d="m10 15 5-3-5-3v6z" />{" "}
  </svg>
);

const MapPlaceholder = () => {
  // We encode the address to make it URL-friendly
  const encodedAddress = encodeURIComponent(
    "Govardhan Energies LLP, Pij, Gujarat 387230",
  );
  const mapUrl = `https://www.google.com/maps/embed/v1/place?key=YOUR_GOOGLE_MAPS_API_KEY&q=${encodedAddress}`;

  // ALTERNATIVE: If you don't have an API Key, use the standard search embed (No Key Required):
  const simpleEmbedUrl = `https://maps.google.com/maps?q=${encodedAddress}&t=&z=15&ie=UTF8&iwloc=&output=embed`;

  return (
    <div className="relative w-full h-80 md:h-96 rounded-lg overflow-hidden border border-gray-200 shadow-lg">
      <iframe
        title="Corporate Office Location"
        className="w-full h-full border-0"
        loading="lazy"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
        /* Using the No-Key-Required version for immediate fix */
        src={simpleEmbedUrl}
      ></iframe>

      {/* <div className="absolute top-4 left-4 p-4 bg-white rounded-lg shadow-xl w-2/4 max-w-sm border border-gray-100 z-10">
        <h3 className="text-xs font-bold text-blue-700">
          Govardhan Energies LLP
        </h3>
        <p className="text-[14px]  text-gray-600 mt-1">
          Sr. No. 2373, Sim Vistar, At & Po-Pij, Ta-Vaso, Dist-Nadiad, Gujarat
          387230
        </p>
        <div className="flex justify-between items-center text-[14px]  mt-2 text-[#1C233A] border-t pt-2">
          <span>4.7 ⭐ 118 reviews</span>
          <a
            href="https://maps.app.goo.gl/Q4BePRTGYcK6yCWvr" // Updated to a standard share format
            target="_blank"
            rel="noopener noreferrer"
            className="text-[14px] text-blue-500 hover:text-blue-700"
          >
            View larger map
          </a>
        </div>
      </div> */}
    </div>
  );
};

const FormInput = ({
  label,
  name,
  value,
  onChange,
  error,
  type = "text",
  half = false,
  isSelect = false,
  options = [],
}) => {
  const inputId = `input-${name}`;
  return (
    <div
      className={`relative w-full ${half ? "md:w-[calc(50%-0.5rem)]" : "w-full"} mb-6`}
    >
      <div className="relative">
        {isSelect ? (
          <>
            <select
              id={inputId}
              name={name}
              value={value}
              onChange={onChange}
              className={`w-full bg-transparent border-0 border-b ${error ? "border-red-500" : "border-gray-400"} focus:border-b-2 focus:border-[#1C233A] focus:outline-none py-1.5 pr-8 appearance-none cursor-pointer`}
            >
              <option value="" disabled>
                {label}
              </option>
              {options.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
            <div className="absolute right-0 top-1/2 -translate-y-1/2 pointer-events-none text-gray-500">
              <ChevronDown size={18} strokeWidth={2.5} />
            </div>
          </>
        ) : (
          <>
            <input
              id={inputId}
              type={type}
              name={name}
              value={value}
              onChange={onChange}
              className={`w-full bg-transparent border-0 border-b ${error ? "border-red-500" : "border-gray-400"} focus:border-b-2 focus:border-[#1C233A] focus:outline-none py-1.5 peer`}
              placeholder=" "
            />
            <label
              htmlFor={inputId}
              className={`absolute left-0 -top-[30px] text-sm cursor-text ${error ? "text-red-500" : "text-[#1C233A]"} transition-all peer-placeholder-shown:text-base peer-placeholder-shown:top-1.5 peer-focus:-top-[30px] peer-focus:text-sm`}
            >
              {label}
            </label>
          </>
        )}
      </div>
      {error && (
        <p className="text-red-500 text-[12px] lg:text-[14px] mt-1 absolute">
          {error}
        </p>
      )}
    </div>
  );
};

const HeroSection = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    contact: "",
    enquiryType: "",
    country: "",
    state: "",
    city: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [captcha, setCaptcha] = useState({
    num1: 0,
    num2: 0,
    result: 0,
    question: "",
  });
  const [userCaptcha, setUserCaptcha] = useState("");

  const generateCaptcha = () => {
    const n1 = Math.floor(Math.random() * 10);
    const n2 = Math.floor(Math.random() * 10);
    setCaptcha({
      num1: n1,
      num2: n2,
      result: n1 + n2,
      question: `${n1} + ${n2} = ?`,
    });
    setUserCaptcha("");
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    let newErrors = {};
    if (!formData.firstName.trim())
      newErrors.firstName = "First name is required";
    if (!formData.lastName.trim()) newErrors.lastName = "Last name is required";
    if (!formData.enquiryType)
      newErrors.enquiryType = "Please select enquiry type";
    if (!formData.city.trim()) newErrors.city = "City is required";
    if (!formData.country.trim()) newErrors.country = "Country is required";

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email))
      newErrors.email = "Invalid email address";

    if (formData.contact.length < 10)
      newErrors.contact = "Enter valid contact number";

    if (parseInt(userCaptcha) !== captcha.result) {
      newErrors.captcha = "Wrong captcha result";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // --- API INTEGRATION START ---
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setIsSubmitting(true);

    try {
      const res = await fetch(
        "https://www.govardhannathjienergies.com/api/submit-inquiry.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            first_name: formData.firstName,
            last_name: formData.lastName,
            email: formData.email,
            contact_no: formData.contact,
            enquiry_type: formData.enquiryType,
            country: formData.country,
            state: formData.state,
            city: formData.city,
            message: formData.message,
            captcha_question: captcha.question,
            captcha_answer: userCaptcha,
          }),
        },
      );

      const data = await res.json();

      if (data.status === true) {
        alert("✅ Inquiry submitted successfully!");
        // Reset Form
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          contact: "",
          enquiryType: "",
          country: "",
          state: "",
          city: "",
          message: "",
        });
        setUserCaptcha("");
        generateCaptcha();
      } else {
        alert("❌ " + (data.message || "Something went wrong"));
      }
    } catch (err) {
      console.error("Inquiry submit error:", err);
      alert("❌ Server connection error. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };
  // --- API INTEGRATION END ---

  return (
    <>
      <Header />
      <div className="font-[Sora] min-h-screen bg-white py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            <div className="space-y-10">
              <div className="space-y-4">
                <h2 className="text-[24px] lg:text-xl font-semibold text-gray-700">
                  Corporate office
                </h2>
                <div className="flex items-start space-x-3 text-gray-600">
                  <MapPin className="w-5 h-5 flex-shrink-0 mt-1" />
                  <p className="leading-relaxed">
                    Sr. No. 2373, Sim Vistar, At & Po-Pij, Ta-Vaso, Dist-Kheda,
                    Gujarat INDIA 387230
                  </p>
                </div>
                <div className="flex flex-col sm:flex-row sm:space-x-8 space-y-2 sm:space-y-0 pt-2">
                  <a
                    href="mailto:info@utpann.in"
                    className="flex items-center space-x-2 text-gray-700 hover:text-blue-600"
                  >
                    <Mail className="w-5 h-5 text-[#1C233A]" />
                    <span className="border-b border-dashed border-gray-400">
                      info@utpann.in
                    </span>
                  </a>
                  <a
                    href="tel:+918645888881"
                    className="flex items-center space-x-2 text-gray-700 hover:text-blue-600"
                  >
                    <Phone className="w-5 h-5 text-[#1C233A]" />
                    <span className="border-b border-dashed border-gray-400">
                      +91 86 45 88 88 81
                    </span>
                  </a>
                </div>
              </div>
              <div className="pt-4">
                <MapPlaceholder />
              </div>
            </div>

            <div className="bg-amber-50 p-6 md:p-10 rounded-lg shadow-lg">
              <p className="text-sm text-gray-600 mb-[60px]">
                Fields marked with * are mandatory
              </p>
              <form
                onSubmit={handleSubmit}
                className="flex flex-wrap justify-between gap-4"
              >
                <FormInput
                  label="First Name*"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  error={errors.firstName}
                  half
                />
                <FormInput
                  label="Last Name*"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  error={errors.lastName}
                  half
                />
                <FormInput
                  label="Email Id*"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  error={errors.email}
                  half
                />
                <FormInput
                  label="Contact No.*"
                  name="contact"
                  type="number"
                  value={formData.contact}
                  onChange={handleChange}
                  error={errors.contact}
                  half
                />
                <FormInput
                  label="Select Enquiry Type*"
                  name="enquiryType"
                  isSelect
                  half
                  value={formData.enquiryType}
                  onChange={handleChange}
                  error={errors.enquiryType}
                  options={[
                    "General Enquiry",
                    "Product Enquiry",
                    "Dealership Enquiry",
                    "Others",
                  ]}
                />
                <FormInput
                  label="Country*"
                  name="country"
                  half
                  value={formData.country}
                  onChange={handleChange}
                  error={errors.country}
                />
                <FormInput
                  label="State"
                  name="state"
                  half
                  value={formData.state}
                  onChange={handleChange}
                />
                <FormInput
                  label="City*"
                  name="city"
                  half
                  value={formData.city}
                  onChange={handleChange}
                  error={errors.city}
                />

                <div className="relative w-full mb-6">
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="w-full bg-transparent border-0 border-b border-gray-400 focus:border-b-2 focus:border-[#1C233A] focus:outline-none py-1.5 peer resize-none"
                    rows="3"
                    placeholder=" "
                  ></textarea>
                  <label className="absolute left-0 -top-[30px] text-sm text-[#1C233A] transition-all peer-placeholder-shown:text-base peer-placeholder-shown:top-1.5 peer-focus:-top-[30px] peer-focus:text-sm">
                    Message
                  </label>
                </div>

                <div className="w-full flex flex-col sm:flex-row items-start gap-4">
                  <div className="flex items-center gap-3 bg-white px-4 py-2 rounded border border-gray-300">
                    <span className="text-[16px] font-bold tracking-widest">
                      {captcha.question}
                    </span>
                    <button
                      type="button"
                      onClick={generateCaptcha}
                      className="p-1 hover:bg-gray-100 rounded-full"
                    >
                      <RefreshCcw size={16} />
                    </button>
                  </div>
                  <div className="relative flex-1 mt-5 sm:mt-0 w-full">
                    <input
                      type="text"
                      value={userCaptcha}
                      onChange={(e) => {
                        setUserCaptcha(e.target.value);
                        if (errors.captcha)
                          setErrors({ ...errors, captcha: "" });
                      }}
                      className={`w-full bg-transparent border-0 border-b ${errors.captcha ? "border-red-500" : "border-gray-400"} focus:outline-none py-1.5 peer`}
                      placeholder=" "
                    />
                    <label className="absolute left-0 -top-[30px] text-sm text-[#1C233A] transition-all peer-placeholder-shown:text-base peer-placeholder-shown:top-1.5 peer-focus:-top-[30px] peer-focus:text-sm">
                      Enter Captcha Result*
                    </label>
                    {errors.captcha && (
                      <p className="text-red-500 text-[12px] lg:text-[14px] mt-1 absolute">
                        {errors.captcha}
                      </p>
                    )}
                  </div>
                </div>

                <div className="w-full mt-8">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className={`px-8 py-3 bg-[#1C233A] text-white font-semibold rounded hover:bg-slate-800 transition-colors ${isSubmitting ? "opacity-50 cursor-not-allowed" : ""}`}
                  >
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeroSection;
